import React from 'react';
import './CheckoutLoyalty.css';
import { Utils } from '../../Utils';
import i18n from '../../i18n/i18n.js';

class CheckoutLoyalty extends React.Component {
  
  state = {
    useLoyaltyPoints: false,
  };

  componentDidMount() {
    // Inicializáljuk az értékeket a formData-ból ha vannak
    const { formData } = this.props;

    if (formData && formData.select_loyalty_points) {
      this.setState({ 
        useLoyaltyPoints: formData.select_loyalty_points === 1 || formData.select_loyalty_points === '1'
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Ha a formData megváltozott, frissítjük a state-et
    const { formData } = this.props;
    
    if (formData && formData.select_loyalty_points !== prevProps.formData?.select_loyalty_points) {
      const newValue = formData.select_loyalty_points === 1 || formData.select_loyalty_points === '1';
      this.setState({ 
        useLoyaltyPoints: newValue
      });
    }
  }

  /**
   * KÖTELEZŐ metódus - ezt hívja meg a Form komponens az elküldéskor
   */
  getFormData() {
    return {
      select_loyalty_points: this.state.useLoyaltyPoints ? 1 : 0
    };
  }

  handleCheckboxChange = (checked) => {
    this.setState({ useLoyaltyPoints: checked }, () => {
      // Újratöltjük a formot a frissített adatokkal
      if (this.props.onLoyaltyChange) {
        this.props.onLoyaltyChange(checked);
      }
    });
  }

  render() {
    const { fullFormResponse, appRef } = this.props;
    const { useLoyaltyPoints } = this.state;
    
    const response = fullFormResponse || {};
    const shopping_cart = response.shopping_cart || {};
    const loyalty_points_system = shopping_cart?.discounts?.loyalty_points_system || {};
    const settings = loyalty_points_system.settings || {};
    
    // Hűségpont adatok kinyerése
    const loyalty_points = loyalty_points_system.loyalty_points || 0;
    const available_loyalty_points = loyalty_points_system.avaible_loyalty_points || 0;
    const order_loyalty_points = loyalty_points_system.order_loyalty_points || 0;
    
    // Beállítások
    const end_time = settings.end_time || 0;

    if (loyalty_points <= 0) {
      return null; // Ha nincs hűségpont, ne jelenjen meg a blokk
    }
    
    // Dátum formázás
    const formatDate = (timestamp) => {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('hu-HU');
    };
    
    const end_date = formatDate(end_time);
    
    return (
      <div className='form_block_summary checkout_user_loyalty_block'>
        <div className='loyalty_content'>          
          {loyalty_points > 0 && (
            <div className='loyalty_info_block'>
              <div className='loyalty_info_text'>
                <input 
                  type="checkbox"
                  id="select_loyalty_points"
                  name="select_loyalty_points"
                  checked={useLoyaltyPoints}
                  onChange={(e) => this.handleCheckboxChange(e.target.checked)}
                />
                <label htmlFor='select_loyalty_points'>
                  <span>
                    {i18n.t('loyaltyPointsUseCheckbox')} 

                    {i18n.t('loyaltyPointsAvailableInfo', {
                      availablePoints: available_loyalty_points,
                      pointsInCurrency: Utils.format_currency(available_loyalty_points, appRef?.current?.currency_settings)
                    })}

                    <br/>

                    {end_date && (
                      <div className='loyalty_date_info'>
                        {i18n.t('loyaltyPointsDateInfo', {
                          endDate: end_date
                        })}
                      </div>
                    )}
                  </span>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CheckoutLoyalty;
